module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "title-chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781429922906_toc01#toctitle6",
      "id": "title6"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "u"
  }, [_vm._v("CHAPTER 1")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "subtitle-chapter"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE POW HOSTAGE PLAN AND ITS IMPLEMENTATION")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_c('span', [_vm._v("The war may last five, ten, twenty or more years. Hanoi, Haiphong and other cities and enterprises may be destroyed … [but] once victory is won, our people will rebuild their country and make it even more prosperous and beautiful.")])]), _vm._v(" "), _c('div', {
    staticClass: "source"
  }, [_c('span', [_vm._v("—HO CHI MINH")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("John Kennedy was assassinated in Dallas, Texas, on November 22, 1963, some eleven months after the Bay of Pigs prisoners were released. He was succeeded in office by his vice president, Lyndon Baines Johnson, the former U.S. Senator from Texas.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("In early 1964, Johnson, while continuing the gradual buildup of U.S. forces in South Vietnam that Kennedy and he had begun soon after taking office in 1961, approved a covert plan to conduct hit-and-run attacks against coastal targets in North Vietnam. The plan, known as Op Plan 34-A, was a joint South Vietnamese/U.S. effort designed to interdict supplies, munitions, and Communist troops before they could reach South Vietnam. It called for South Vietnamese PT boats to put South Vietnamese commandos ashore at night to blow bridges and attack other transportation-related targets; attack North Vietnamese bases suspected of housing personnel and/or equipment bound for the southern battlefields and other targets of opportunity—all under the watchful eye of U.S. destroyers conducting nighttime “intelligence-gathering operations” just outside North Vietnamese territorial waters in the Gulf of Tonkin."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429922906_bm03#end_en3",
      "id": "ref_end_en3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("1")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("The North Vietnamese were hit and hit and hit again throughout the spring and summer of 1964, but did not launch any major military response. Then, after South Vietnamese PT boats shelled two North Vietnamese islands in the Gulf in late July, the North Vietnamese struck back. In the early morning hours of August 2, three of their torpedo boats attacked the USS "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Maddox")]), _vm._v(", one of the U.S. destroyers that had been shadowing the South Vietnamese commando raids. At the time of the attack, the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Maddox")]), _vm._v(" was conducting its nighttime intelligence-gathering operations just off the North Vietnamese coast in international waters.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("The "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Maddox")]), _vm._v(" and U.S. Navy aircraft quickly repelled the North Vietnamese attack, setting fire to one of the boats and sending the others fleeing, but did not carry the fight to the nearby port where the boats were believed based."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429922906_bm03#end_en4",
      "id": "ref_end_en4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("2")])])]), _vm._v(" When news of the attack on the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Maddox")]), _vm._v("—and the Johnson administration’s\nless-than-overwhelming response—reached America, a war fever erupted. Johnson responded by declaring that any further attacks would be met with overwhelming force and by ordering all U.S. forces operating in the Tonkin Gulf to full battle stations. It was in this charged atmosphere that on August 4, crewmen aboard the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Maddox")]), _vm._v(" and its sister ship the USS "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Turner Joy")]), _vm._v(" reported possible but unconfirmed attacks against their vessels during storm-tossed nighttime operations in the Gulf.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Without waiting for confirmation that this second round of attacks had, in fact, occurred, Johnson ordered immediate retaliatory strikes against North Vietnamese coastal targets and ports and submitted what amounted to a declaration of war to Congress. The resolution Johnson submitted, which became known as the Gulf of Tonkin Resolution, authorized him, as president, to take “all necessary measures to repel any armed attacks against the forces of the United States and to prevent further aggression” and to provide all needed military assistance requested by America’s allies in the region. Though some suspected at the time that the reported attacks on August 4 had not actually occurred and were simply being used by the president and his advisors as a pretext for widening the war, the Senate approved the Gulf of Tonkin Resolution on August 7, 1964, by a vote of 88 to 2."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429922906_bm03#end_en5",
      "id": "ref_end_en5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("3")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Knowing what it all meant—a massive buildup of American troop strength and all-out warfare in the South and perhaps years of ruinous U.S. air attacks against the North—the North Vietnamese began planning for a long and potentially very destructive war and, at war’s end, a long and difficult period of reconstruction. U.S. intelligence officials would soon learn that part of the North Vietnamese plan for the war and its aftermath—a key part, in fact—was based on an important lesson they had learned some eighteen months before from Fidel Castro.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('div', {
    staticClass: "title-section1"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781429922906_toc01#toctitle7",
      "id": "title7"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE HOSTAGE PLAN")])])])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Intelligence collected by the U.S. Central Intelligence Agency during the Vietnam War indicates that in 1964, the year the United States first bombed North Vietnam, the North Vietnamese Communist Party Central Committee ordered that all North Vietnamese military personnel and civilians be trained to capture American military personnel alive so that they could be used “as hostages to compel the U.S., in the event of a cease-fire, to pay war reparations for the destruction inflicted upon NVN by the United States.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429922906_bm03#end_en6",
      "id": "ref_end_en6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("4")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("The CIA reported that North Vietnamese authorities began holding training sessions throughout the country to teach the civilian population the procedures they were to follow in capturing and handling downed fliers."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429922906_bm03#end_en7",
      "id": "ref_end_en7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("5")])])]), _vm._v(" CIA sources further reported that the main teaching document used in these sessions was a pamphlet titled “Policy on Treatment of American Prisoners,” which the North Vietnamese government made available to all civilians. Most of the instructional period at the training sessions, these sources reported, was devoted to the section of the pamphlet that dealt with how Americans were to be captured and searched, how their wounds were to be treated, how they were to be protected from harm and then delivered as quickly as possible to the authorities, etc."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429922906_bm03#end_en8",
      "id": "ref_end_en8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("6")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Soldiers of the North Vietnamese army—the Peoples Army of Vietnam (the PAVN) reportedly received similar instruction during basic training or in officer candidate school. The CIA reported that during one session at the Son Tay Officers School west of Hanoi in 1966, the instructor stated that the North Vietnamese government considered U.S. POWs to be of “first-level importance because they will be used as a means of obtaining payment for bomb damages from the U.S. when the war ends.” For that reason, the instructor said, Americans must be captured alive whenever possible, protected, and given good treatment.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("The instructor went on to explain that downed American airmen were to be captured by\n")])]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "blocktext"
  }, [_c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_vm._v("surrounding them and closing in. To shoot to kill was strictly forbidden under any circumstance. If a crew member was armed and resisted capture, he was to be surrounded and volunteers to rush him were to be requested. The volunteers were to charge the man and overpower him. He was not to be killed even if he killed North Vietnamese personnel while resisting capture … .")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent-blocktext"
  }, [_c('span', [_vm._v("… Once capture had been made, the very first act was to search the prisoner for weapons or drugs with which he might kill himself. The prisoner must not be allowed to commit suicide. The second step in the capture was to treat any wounds. Next, the prisoner was to be quickly moved to higher echelons … . No one was to be permitted to beat or otherwise mistreat the prisoner. If someone did, he was [to be] criticized. Prisoners were to be given as much food and water as they wanted … . All of the prisoner’s belongings and equipment were to be confiscated and sent to higher echelons with him. Nothing was to be taken for personal use. If someone did so, he was to be criticized."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429922906_bm03#end_en9",
      "id": "ref_end_en9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("7")])])])])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("To get the POWs back at the end of the war, the instructor told the officer candidates, the United States would have to “exchange equipment for them and build up the country.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429922906_bm03#end_en10",
      "id": "ref_end_en10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("8")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("In a move that underscored the importance the North Vietnamese placed on the matter of postwar reconstruction, the government in Hanoi created in 1966 the Committee of Inquiry and charged it with keeping a day-to-day tally of the damage caused by American bombs. Those appointed to the committee included top officials from the ministries of Health, Foreign Affairs, and Security, as well as high-ranking PAVN officers, the chief of the PAVN Liaison to the International Control Commission, and the president of the People’s Supreme Court. Beginning in 1966, the committee compiled precise information, day by day, factory by factory, village by village, relating to the “material and human damage caused by U.S. bombing.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429922906_bm03#end_en11",
      "id": "ref_end_en11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("9")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('div', {
    staticClass: "title-section1"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781429922906_toc01#toctitle8",
      "id": "title8"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("HANOI’S PLAN TO CAPTURE AMERICANS ALIVE IN THE SOUTH")])])])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Given Hanoi’s plan to capture as many Americans alive as possible in the North and use them as hostages to secure postwar reconstruction aid, it came\nas no surprise to U.S. intelligence officials when they learned of a similar North Vietnamese plan to capture American troops fighting in South Vietnam and use them for the same purpose. The information on the North Vietnamese plan came from PAVN soldiers who had infiltrated down the Ho Chi Minh Trail and had been captured in battle or had turned themselves in to the allies and were later interviewed by U.S. interrogators.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("The PAVN told U.S. interrogators that they had been trained in both basic training and officer candidate school to capture "), _c('em', {
    staticClass: "i"
  }, [_vm._v("surrendering")]), _vm._v(" Americans alive during combat in the South rather than kill them. The PAVN told of similar training sessions being conducted along the Ho Chi Minh Trail during the long trek to the southern battlefields and of reminders being issued to the troops just before battle."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429922906_bm03#end_en12",
      "id": "ref_end_en12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("10")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Wherever the sessions were held, the intelligence indicates the message was the same: Kill as many Americans as possible during battle, but under no circumstances should surrendering Americans be killed; rather, they should be taken alive and quickly removed from the battlefield. PAVN soldiers who violated this policy and executed those Americans who were attempting to surrender or who had already been captured were disciplined."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429922906_bm03#end_en13",
      "id": "ref_end_en13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("11")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("To assist in capturing Americans during ground combat operations, PAVN soldiers were taught to memorize English-language phrases such as “hands up,” “hands down,” “surrender, not die,” “after me,” “go to hospital,” “go to safe area,” etc."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429922906_bm03#end_en14",
      "id": "ref_end_en14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("12")])])]), _vm._v(" In almost every case, these were the only English words in a PAVN soldier’s vocabulary.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("The PAVN were also issued 2½\" × 3½\" “capture cards” prior to battle, which were to be used when direct contact with the prospective American prisoner occurred. Printed on one side were the following English phrases in phonetic Vietnamese and their meanings in English:\n")])]), _vm._v(" "), _c('div', {
    staticClass: "tableau"
  }, [_c('table', {
    staticClass: "none"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "58.53*"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "41.47*"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("(phonetic Vietnamese)")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("(meaning in English)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("xo-ren-do o dai")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("surrender or die")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("gan dao")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("gun down")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("hen ap")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("hands up")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("ton rao")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("turn around")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("not mu")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("do not move")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("go quich")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("go quickly")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("xai-lon")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("silence")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("hoe do men")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("where are your men")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("con dem")]), _vm._v(" "), _c('td', {
    staticClass: "filet_x filet_x ",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("call them")])])])]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('div', {
    staticClass: "p"
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_vm._v("Key words to be used while capturing and dealing with American POWs")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("The reverse side contained a printed message the PAVN were to show the American soldier who was being captured. The message, deliberately misstating the military affiliation of the bearer because the North Vietnamese government refused to acknowledge the presence of PAVN troops in South Vietnam, read in English:\n\n")])]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "blocktext"
  }, [_c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_vm._v("The National Front for Liberation and the Liberation Armed Forces of South Vietnam humanely treat their enemy soldiers who have surrendered [to] them. You are now captured, we do not kill you. Just follow our command!")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent-blocktext"
  }, [_c('span', [_vm._v("We will have your arms tied up and take you to a safe place. Stand up and follow us right now! Only then can your life be assured and you be soon untied. Should you hesitate or refuse to go, you would probably get killed as a result of the air raids and artillery from the American side. We should fight as the U.S. troops come; then your life is hardly safe.")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Printed at the bottom of the card in Vietnamese was: “Show this to American soldiers when you capture them.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429922906_bm03#end_en15",
      "id": "ref_end_en15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("13")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("PAVN policy dictated that American prisoners who had not suffered wounds were to be taken directly to the capturing unit’s headquarters for interrogation. As stated on the “capture card,” these prisoners were to be moved away from the battlefield as quickly as possible for fear they and their captors would be caught in the artillery barrages and air strikes the allies routinely rained down on withdrawing Communist forces.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Wartime intelligence collected from PAVN sources shows that this fear was indeed justified. One PAVN told U.S. interrogators that nine American prisoners who were being escorted away from their point of capture in Kontum Province in the Central Highlands had been caught in one such artillery barrage. The source said that five of the Americans and one guard had been killed, and that all had been buried in a mass grave next to the trail."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429922906_bm03#end_en16",
      "id": "ref_end_en16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("14")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Another PAVN told of seeing two badly injured American servicemen being carried on stretchers by PAVN soldiers in Quang Tin Province on South Vietnam’s northern coast. He said the litter bearers told him the Americans had been captured uninjured in fighting the previous day but had been wounded when a U.S. armed reconnaissance plane attacked the group as they were moving away toward a liberated area."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429922906_bm03#end_en17",
      "id": "ref_end_en17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("15")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Yet another PAVN told how fellow troops had captured twenty-six U.S. soldiers during a battle in Quang Tri Province, the northernmost province in South Vietnam. He reported that the prisoners were being moved from the battlefield under guard when they and their guards were attacked by allied aircraft. He reported that ten American prisoners were killed in the attack and four others wounded, one seriously. He also said that three of the PAVN guards were killed and two others wounded. The source added that a PAVN doctor came to the site of the attack and treated the wounded prisoners and that the Americans and their guards then resumed their journey to a base camp in a secure area."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429922906_bm03#end_en18",
      "id": "ref_end_en18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("16")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("According to a number of the PAVN sources, official policy dictated that all wounded Americans be taken to the nearest field hospital for treatment. Those who were wounded so severely that they could not walk were to be carried."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429922906_bm03#end_en19",
      "id": "ref_end_en19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("17")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Though the intelligence indicates general PAVN compliance with the stated PAVN policy of capturing rather than killing Americans who were attempting to surrender and caring for rather than killing those who had been wounded, revenge killings did occur on a number of occasions. Among these were the killings that occurred during the Battle of the Ia Drang Valley in 1965 when\nPAVN troops sought out the American wounded and executed as many of them as possible, and the killings of American pilots and aircrewmen that reportedly occurred along remote sections of the Ho Chi Minh Trail in Laos."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429922906_bm03#end_en20",
      "id": "ref_end_en20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("18")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('div', {
    staticClass: "title-section1"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781429922906_toc01#toctitle9",
      "id": "title9"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE QUALITY OF THE INTELLIGENCE •")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("THE QUALITY OF THE PAVN AS INTELLIGENCE SOURCES")])])])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("U.S. interrogators found early on that the information provided by the PAVN concerning the American prisoners they had reportedly seen was often highly specific as to date and circumstance. The interrogators concluded that the PAVN were aided in their recall by two factors. First, the soldiers relied on recent specific frames of reference in their highly regimented lives to help them remember the exact date of their sighting—the date they completed basic training, the date they started marching south, the date they crossed the border into Laos, the date they crossed a certain river during infiltration, the date they arrived at a certain rest station along the Ho Chi Minh Trail, the date they arrived in South Vietnam, etc. Second, U.S. interrogators ascribed their highly specific descriptions of the circumstances surrounding the sighting of the American or Americans and the often detailed descriptions of the prisoners to the fact that most PAVN had never before seen an American and when they did the event created an indelible impression upon them."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429922906_bm03#end_en21",
      "id": "ref_end_en21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("19")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Given the novelty of seeing an American and the apparent impact that such sighting had on the PAVN, U.S. interrogators were not surprised to find that the education and intelligence level of the individual PAVN sources seemed to have little bearing on the quality of intelligence each provided. Barely literate PAVN were often able to recall the physical characteristics of individual American POWs they had seen in detail sufficient to allow interrogators to combine the descriptions and the reported date of the sighting with known U.S. battle losses and determine the identity of the Americans with reasonable certainty. On the other end of the education spectrum, captured PAVN doctors were, as one might expect, able to recall clearly the specific surgical procedures they performed on wounded American servicemen in the South and in several cases were able to provide interrogators with their former patients’ names. Captured PAVN nurses and medics were likewise able to remember the specific medications and first aid procedures they administered to dozens of wounded Americans on the battlefields and at aid stations and at field hospitals in the South.")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429922906_i0005.jpg",
      "height": "341px",
      "src": "e9781429922906_i0005.jpg",
      "width": "277px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Two PAVN soldiers captured in South Vietnam in 1967.")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("(U.S. ARMY)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Given where they had come from, what they had seen along the way, and their uncanny ability to recall date and detail, the PAVN were fertile ground indeed for U.S. intelligence officials hungry for information about missing Americans. Their value to the intelligence community was enhanced by the fact that, apparently believing that what they said about American POWs would not adversely affect their country’s war effort, the PAVN were generally willing to share this information openly and without apparent intent to deceive."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429922906_bm03#end_en22",
      "id": "ref_end_en22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("20")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("U.S. military interrogators operating at or under the auspices of one of Saigon’s two main interrogation centers, the Combined U.S./South Vietnamese Military Interrogation Center (CMIC) or the National Interrogation Center (NIC), conducted most of the PAVN interrogations. As a matter of routine, at the end of each interview the interrogator assigned each case an evaluation of F-6 on the standard intelligence community evaluation scale. This meant “credibility of source unknown/credibility of information cannot be judged.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429922906_bm03#end_en23",
      "id": "ref_end_en23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("21")])])]), _vm._v(" The F was routinely assigned for the obvious reason that each captured or surrendered PAVN had, by virtue of his past service, never before provided intelligence to the U.S. government and thus had not established himself as a reliable source over time. The 6 was routinely assigned because the information provided by the source had almost always originated behind enemy lines and thus did not lend itself to on-site verification.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("In addition to the standard letter/number evaluation, the interrogator would often add comments concerning the demeanor and perceived truthfulness of the source. An example of one interrogator’s comments and the relationship of these comments to the letter/number evaluation assigned to the PAVN source is noted below:\n")])]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "blocktext"
  }, [_c('div', {
    staticClass: "title-blocktext"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("COMMENTS OF THE COLLECTOR")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent-blocktext"
  }, [_c('span', [_vm._v("5. (u) Source was cooperative during the interrogation and answered all questions willingly. He appeared to be of average intelligence and correctly responded to control questions with acceptable consistency. The interrogator felt that source was not withholding information and related facts to the best of his ability. Source appeared to be truthful during the interrogation.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent-blocktext"
  }, [_c('span', [_vm._v("6. Evaluation: Source "), _c('span', {
    staticClass: "u"
  }, [_vm._v("F")]), _vm._v(" Information "), _c('span', {
    staticClass: "u"
  }, [_vm._v("6")]), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429922906_bm03#end_en24",
      "id": "ref_end_en24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("22")])])])])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Individual administrative evaluations aside, in the final analysis U.S. intelligence officials considered the PAVN to be rock-solid sources of intelligence on\nU.S. POWs. The deputy director of the CIA would later state that captured PAVN provided “very valuable information on the Communist prison system, techniques, and policy of exploiting prisoners, locations of prisons, and, less frequently, actual identification of prisoners."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429922906_bm03#end_en25",
      "id": "ref_end_en25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("23")])])]), _vm._v(" Sedgwick D. Tourison Jr., a U.S. Army warrant officer who interrogated many PAVN for the CMIC during the war, would later pay these soldiers the intelligence community’s highest possible compliment. Tourison, who received special commendation for his outstanding service at CMIC from the head of the center, Maj. Gen. Joseph A. McChristian, USA, and went on to work for the Defense Intelligence Agency in Washington, wrote of the PAVN, “There were a lot of observations we could make about those soldiers from north of the seventeenth parallel. We found that most simply told the truth when asked questions.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429922906_bm03#end_en26",
      "id": "ref_end_en26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("24")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('div', {
    staticClass: "title-section1"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781429922906_toc01#toctitle10",
      "id": "title10"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("VIETCONG POLICY RELATING TO THE CAPTURE AND TREATMENT OF AMERICAN SERVICEMEN")])])])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Intelligence collected during the war from captured Vietcong and from Hoi Chanhs—Communist Southerners who turned themselves in to the South Vietnamese government under the Chieu Hoi (open arms) program—indicates the Vietcong generally followed PAVN guidelines when dealing with American prisoners.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("The VC, like their northern cousins, operated under the principle that “once captured, the prisoners served a more ‘useful’ purpose [if] they were kept alive.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429922906_bm03#end_en27",
      "id": "ref_end_en27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("25")])])]), _vm._v(" Just like the PAVN, the VC were instructed to capture Americans alive whenever possible."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429922906_bm03#end_en28",
      "id": "ref_end_en28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("26")])])]), _vm._v(" The VC considered American servicemen to be “excellent hostages” who would be traded at war’s end either for reconstruction aid or for Vietcong prisoners held by the South Vietnamese."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429922906_bm03#end_en29",
      "id": "ref_end_en29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("27")])])]), _vm._v(" One VC source told U.S. interrogators that “for one returned officer pilot, the U.S. had to compensate NVN with a factory.” He also reported hearing that the rate of exchange for prisoners would be “one U.S. soldier … for 10 VC soldiers.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429922906_bm03#end_en30",
      "id": "ref_end_en30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("28")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Vietcong sources reported that torturing American prisoners or harming them in any way was strictly prohibited, and that any VC who did so was to be subjected to “severe punishment.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429922906_bm03#end_en31",
      "id": "ref_end_en31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("29")])])]), _vm._v(" The exact form of punishment appeared to vary from unit to unit. One VC source reported that his unit was instructed that anyone who shot an American who had ceased resistance and come forward with his hands up would himself be shot."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429922906_bm03#end_en32",
      "id": "ref_end_en32",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("30")])])]), _vm._v(" In other units the penalties for killing an American who could have been captured ranged from demotion in rank to severe reprimand."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429922906_bm03#end_en33",
      "id": "ref_end_en33",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("31")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Combat atrocities and revenge killings did occur, and the captured VC and the Hoi Chanhs occasionally reported the details of these events."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429922906_bm03#end_en34",
      "id": "ref_end_en34",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("32")])])]), _vm._v(" Despite the atrocities, MACV, the U.S. Military Assistance Command in Vietnam, stated in its 1970 "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Command History")]), _vm._v(" that “the VC continue a policy of leniency towards captured Americans … . Some atrocities … have occurred, but they stand out because they have been so few.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429922906_bm03#end_en35",
      "id": "ref_end_en35",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("33")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Like the PAVN, VC soldiers were ordered to “learn … by heart” several English phrases that would aid them in capturing Americans. These phrases included\n"), _c('em', {
    staticClass: "i"
  }, [_vm._v("“hen-xap”")]), _vm._v(" (hands up), "), _c('em', {
    staticClass: "i"
  }, [_vm._v("“hon-t”")]), _vm._v(" (halt), "), _c('em', {
    staticClass: "i"
  }, [_vm._v("“gan-dao-n”")]), _vm._v(" (throw your weapon down), "), _c('em', {
    staticClass: "i"
  }, [_vm._v("“xitdao-n”")]), _vm._v(" (sit down), "), _c('em', {
    staticClass: "i"
  }, [_vm._v("“get-ap”")]), _vm._v(" (get up), and "), _c('em', {
    staticClass: "i"
  }, [_vm._v("“gau”")]), _vm._v(" (go)."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429922906_bm03#end_en36",
      "id": "ref_end_en36",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("34")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("The VC were under orders to take all Americans who were captured unhurt to higher headquarters for interrogation. If the escort force was subjected to an air strike en route to the headquarters area, members were to give first priority to the safety of their prisoner."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429922906_bm03#end_en37",
      "id": "ref_end_en37",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("35")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("VC policy dictated that those Americans who had been wounded and left for dead on the battlefield or wounded during capture were to be given first aid and then removed to the nearest aid station or field hospital for additional treatment. According to MACV, the administration of this medical care to wounded GIs was “the most often adhered to [tenet] of VC policy regarding American prisoners.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429922906_bm03#end_en38",
      "id": "ref_end_en38",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("36")])])]), _vm._v(" One captured VC reported that in instances where VC cadre and U.S. POWs required medical treatment at the same time, the American prisoners were given attention first, unless the VC were more seriously wounded."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429922906_bm03#end_en39",
      "id": "ref_end_en39",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("37")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“Instances where the VC have killed wounded Americans in lieu of taking them prisoner,” MACV declared in its 1970 "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Command History")]), _vm._v(", “are extremely rare.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/e9781429922906_bm03#end_en40",
      "id": "ref_end_en40",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("38")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-703961e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781429922906_c02.vue
// module id = 75
// module chunks = 0